module.exports = __webpack_public_path__ + "img/img_qrcode.14f2f58a.png";